import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
import MenuIcon from "@mui/icons-material/Menu";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import React, { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import PsContext from "../../context";
import { IMG_MENU_BAR, upperCase } from "../../utils";
import RightSidebar from "../rightSidebar";
import RightSideDrawer from "../rightSidebar/rightSideDrawer";
import NotificationBadge from "./NotificationBadge";

const Header = (props) => {
  const context = useContext(PsContext);
  const navigate = useNavigate();
  const [showSidebar, setShowSidebar] = useState(false);
  const [notificationCount, setNotificationCount] = useState([]);

  useEffect(() => {
    /*window.onscroll = function () {
      myFunction();
    };

    // Get the navbar
    var navbar = document.getElementById("ps__top__menu");

    // Get the offset position of the navbar
    var sticky = 240; //navbar.offsetTop;

    // Add the sticky class to the navbar when you reach its scroll position. Remove "sticky" when you leave the scroll position
    function myFunction() {
      if (window.pageYOffset >= sticky) {
        navbar.classList.add("darkHeader");
      } else {
        navbar.classList.remove("darkHeader");
      }
    }*/
  }, []);
  const linkClick = (toUrl) => {
    navigate(toUrl);
  };
  const backButtonClick = () => {
    if (props.onBack) props.onBack();
    else navigate("/stu/app");
  };

  const getBackButton = () => {
    if (props.noBack) return <div className="back-button me-2 me-2"></div>;
    return props.backAction ? (
      <div className="back-button me-2 me-2">
        <a onClick={(e) => backButtonClick()}>
          <i className="fa-solid fa-arrow-left-long"></i>
          {/*<i className="fa-solid fa-chevron-left"></i>*/}
        </a>
      </div>
    ) : (
      <>
        <div class="logo-wrapper fw-bold text-primary">
          {/*<img
            src={IMG_MENU_BAR.default}
            className="img-fluid"
            alt=""
            style={{ marginTop: "-8px" }}
          />

          {/*<span className="brand-logo-text">
            {props.title || context.settingValue("college_app_short_name")}
    </span>*/}
          {context.settingValue("college_app_short_name")}
        </div>
      </>
    );
  };

  return (
    <>
      <Box sx={{ flexGrow: 1 }}>
        <AppBar position="fixed">
          <Toolbar>
            {!props.noBack && (
              <IconButton
                size="large"
                edge="start"
                color="inherit"
                aria-label="menu"
                sx={{ mr: 2 }}
                onClick={(e) => backButtonClick()}
              >
                <KeyboardBackspaceIcon />
              </IconButton>
            )}
            <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
              {props.title ||
                upperCase(context.settingValue("billheader_name"))}
            </Typography>

            {!props.rightActions && (
              <>
                <NotificationBadge />
                <IconButton
                  size="large"
                  aria-label="menu"
                  aria-controls="menu-appbar"
                  aria-haspopup="true"
                  color="inherit"
                  onClick={(e) => setShowSidebar(!showSidebar)}
                >
                  <MenuIcon />
                </IconButton>
              </>
            )}
            {props.rightActions || ""}
          </Toolbar>
        </AppBar>
      </Box>
      <RightSideDrawer
        visible={showSidebar}
        onHide={(e) => setShowSidebar(false)}
        {...props}
      />
    </>
  );
};
export default Header;
